module.exports = __webpack_public_path__ + "static/media/xlvets.a525c935.png";